export const globalVariableDefaults = {
    isAdministrator: false,
    canViewDashboard: true
  };